//Endpoints
export const LOGIN_URL = '/wbe/CommandServlet?command=login&login=wbe';
export const CAPTCHA_SERVLET_URL = '/wbe/CaptchaServlet?id=';
export const SIGNUP_URL = '/wbe/RegistrationServlet';

//Cookies
export const ATI_WBE_DIRECT_COOKIE = 'ATIWBEDIRECT';
